import React, { useEffect } from "react";
import "../components/BetterWMS";
import { renderToString } from "react-dom/server";
import * as L from "leaflet";
import "leaflet-geoserver-request";
import "leaflet-groupedlayercontrol";
import { GEOSERVER_API_URL } from "../../../actions/types";
import basemaps from "../components/basemaps";
import "../components/leaflet-slider/leaflet-slider";
import "../components/leaflet-color-control/leaflet-color-control";
import "../components/leaflet-search-coordinates/leaflet-search-coordinates";
import chroma from "chroma-js";

export const EmereGDP = () => {
  var map = null;

  const mapPopup = (properties) => {
    return renderToString();
  };

  // Country layer
  const GDPLayer = L.tileLayer.betterWms(
    GEOSERVER_API_URL,
    {
      layers: "res:gdp_grid",
      tiled: true,
      format: "image/png",
      transparent: true,
      version: "1.3.0",
      opacity: 1,
      height: 256,
      width: 256,
    },
    mapPopup
  );
  // Region layer
  const emereLayer = L.tileLayer.betterWms(
    GEOSERVER_API_URL,
    {
      layers: "res:emere_points",
      tiled: true,
      format: "image/png",
      transparent: true,
      version: "1.3.0",
      opacity: 1,
      height: 256,
      width: 256,
    },
    mapPopup
  );

  // Basemaps + Layers
  const groupLayer = L.control.groupedLayers(
    {
      Light: basemaps[0],
      Classico: basemaps[1],
      Topologia: basemaps[2],
      Satellite: basemaps[3],
      Fisica: basemaps[4],
    },
    {
      Layers: {
        GDP: GDPLayer,
        Emere: emereLayer,
      },
    },
    {}
  );

  const searchCoordinates = L.control.searchCoordinates();

  useEffect(() => {
    map = L.map("map", {
      zoomSnap: 1,
      minZoom: 2,
      layers: [basemaps[0], GDPLayer],
      preferCanvas: true,
      maxBoundsViscosity: 1,
    }).setView([55, 75], 3);

    map.doubleClickZoom.disable();

    map.on("click", function (e) {
      var coord = e.latlng;
      var lat = coord.lat;
      var lng = coord.lng;
      console.log(
        "You clicked the map at latitude: " + lat + " and longitude: " + lng
      );
    });

    groupLayer.setPosition("topleft").addTo(map);
    searchCoordinates.setPosition("bottomright").addTo(map);
    map.eachLayer((layer) => {
      console.log(layer);
    });
    return () => {
      map.off();
      map.remove();
    };
  }, []);

  return <div id="map" style={{ height: "100%", width: "100%" }} />;
};

export default EmereGDP;
